// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"36":"picker","177":"home","882":"wallet"}[chunkId] + "." + {"36":"0631ecce","177":"a96cadb3","882":"c28dd264"}[chunkId] + ".css";
};